"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomComponents = exports.SingleValue = exports.MultiValue = exports.CustomOption = exports.OptionItem = exports.Icon = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_select_1 = require("react-select");
var style_1 = require("../../../style");
var Text_1 = __importDefault(require("../../Text"));
var layout_1 = require("../../layout");
var data_display_1 = require("../../data-display");
var icons_1 = require("../../../icons");
var BaseOption = react_select_1.components.Option, BaseMultiValue = react_select_1.components.MultiValue, BaseSingleValue = react_select_1.components.SingleValue, BaseDropdownIndicator = react_select_1.components.DropdownIndicator, BaseControl = react_select_1.components.Control, BaseSelectContainer = react_select_1.components.SelectContainer;
var Icon = function (_a) {
    var showDot = _a.showDot, showUserIcon = _a.showUserIcon, imageUrl = _a.imageUrl, multi = _a.multi, disabled = _a.disabled;
    if (showDot) {
        return react_1.jsx(data_display_1.Dot, { size: "md", color: "Success" });
    }
    if (showUserIcon) {
        return (react_1.jsx(data_display_1.Avatar, { name: "", size: multi ? '2xs' : 'xs', placeholderType: "icon", css: { opacity: disabled ? 0.6 : undefined } }));
    }
    if (imageUrl) {
        return (react_1.jsx(data_display_1.Avatar, { name: "", src: imageUrl, size: multi ? '2xs' : 'xs', placeholderType: "icon", css: { opacity: disabled ? 0.6 : undefined } }));
    }
    return null;
};
exports.Icon = Icon;
var formatTitle = function (label, subLabel) { return subLabel ? label + "\n" + subLabel + "\n" : label; };
var OptionItem = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, imageUrl = _a.imageUrl, showDot = _a.showDot, showUserIcon = _a.showUserIcon, disabled = _a.isDisabled;
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 8, css: { overflow: 'hidden' }, title: formatTitle(label, subLabel) },
        react_1.jsx(exports.Icon, { showDot: showDot, showUserIcon: showUserIcon, imageUrl: imageUrl, disabled: disabled }),
        react_1.jsx("span", { css: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
            react_1.jsx(Text_1.default.Body, { size: "md", color: disabled ? style_1.DesignSystemThemeColor.Gray.LIGHT_2 : style_1.DesignSystemThemeColor.Gray.DARK_4 }, label),
            subLabel ? (react_1.jsx(Text_1.default.Body, { css: { marginLeft: 8 }, size: "md", color: disabled ? style_1.DesignSystemThemeColor.Gray.LIGHT_2 : style_1.DesignSystemThemeColor.Gray.DEFAULT }, subLabel)) : null)));
};
exports.OptionItem = OptionItem;
var CustomOption = function (_a) {
    var showDot = _a.showDot, showUserIcon = _a.showUserIcon, props = __rest(_a, ["showDot", "showUserIcon"]);
    var data = props.data, isSelected = props.isSelected;
    return (react_1.jsx(BaseOption, __assign({}, props),
        react_1.jsx(exports.OptionItem, __assign({}, data, { showDot: showDot, showUserIcon: showUserIcon })),
        isSelected ? (react_1.jsx(icons_1.Check, { css: { minWidth: 20, minHeight: 20 }, size: 20, color: style_1.DesignSystemThemeColor.Primary.DARK_1 })) : null));
};
exports.CustomOption = CustomOption;
var MultiValue = function (_a) {
    var showDot = _a.showDot, showUserIcon = _a.showUserIcon, props = __rest(_a, ["showDot", "showUserIcon"]);
    return (react_1.jsx(BaseMultiValue, __assign({}, props),
        react_1.jsx(layout_1.Flex, { alignItems: "center", gap: 5, title: props.data.label },
            react_1.jsx(exports.Icon, { showDot: showDot, showUserIcon: showUserIcon, imageUrl: props.data.imageUrl, multi: true }),
            react_1.jsx(Text_1.default.Body, { css: { overflow: 'hidden', textOverflow: 'ellipsis' }, weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_2 }, props.data.selectedLabel || props.data.label))));
};
exports.MultiValue = MultiValue;
var SingleValue = function (_a) {
    var showDot = _a.showDot, showUserIcon = _a.showUserIcon, props = __rest(_a, ["showDot", "showUserIcon"]);
    return (react_1.jsx(BaseSingleValue, __assign({}, props),
        react_1.jsx(exports.OptionItem, __assign({}, props, props.data, { label: props.data.selectedLabel || props.data.label, showDot: showDot, showUserIcon: showUserIcon }))));
};
exports.SingleValue = SingleValue;
var createCustomComponents = function (_a) {
    var readOnly = _a.readOnly;
    return ({
        IndicatorSeparator: function () { return null; },
        DropdownIndicator: function (props) { return (props.isMulti && props.hasValue) || props.selectProps.isLoading
            ? null
            : react_1.jsx(BaseDropdownIndicator, __assign({}, props)); },
        Control: function (props) { return (react_1.jsx(BaseControl, __assign({}, props, { isDisabled: readOnly || props.isDisabled }))); },
        SelectContainer: function (props) { return (react_1.jsx(BaseSelectContainer, __assign({}, props, { isDisabled: readOnly || props.isDisabled }))); },
    });
};
exports.createCustomComponents = createCustomComponents;
